import React from "react";
import "../../styles/footer.css";

const Footer = () => {
  return (
    <div className="flex-1 flex text-xl font-bold text-gray-800 mb-2  items-center justify-center">
      <p>© 2025 Sahaj Gyan. All rights reserved.</p>
    </div>
  );
};

export default Footer;